import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        occurrence: '=',
        canManageOccurrences: '=',
        courseVersions: '=',
        course: '=',
        sites: '=',
        directManagers: '='
    },
    template: `
        <div>
            <courses-courses-edit-occurrence-steps-general
                form="vm.form"
                occurrence="vm.occurrence"
                can-manage-occurrences="vm.canManageOccurrences"
                course-versions="vm.courseVersions"
                direct-managers="vm.directManagers"
                course="vm.course"
                sites="vm.sites"
                context="'edit'"
            />
        </div>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(
            this.occurrence,
            model => model.$update({ id: model.id, expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,sites' })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/edit/general/index.js